import { SecurityGroup } from './';

export class ReportSecurityGroup {

    public ReportSecurityGroupId:string;

    public ReportId:string;

    public SecurityGroupId:string;

    public SecurityGroup:SecurityGroup;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/report-security-group.ts